import { render } from "./Object.vue?vue&type=template&id=7da92979&scoped=true"
import script from "./Object.vue?vue&type=script&lang=js"
export * from "./Object.vue?vue&type=script&lang=js"

import "./Object.vue?vue&type=style&index=0&id=7da92979&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7da92979"

export default script